<script lang="ts" setup>
import UserCenter from './user-center.vue'
import ModifyPwd from './modify-pwd.vue'
import { useAppStore } from '@/store/app'
import { RouterEnum } from '@/enums/routerEnum'

const userCenterCtr = ref(false)
const modifyPwdCtr = ref(false)
const router = useRouter()
const appStore = useAppStore()

const open = async () => {
	ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
	})
		.then(async () => {
			await appStore.logout()
			router.replace(RouterEnum.LOGIN_PAGE_PATH)
		})
		.catch(() => {})
}
</script>

<template>
	<el-dropdown trigger="hover">
		<span class="el-dropdown-link">
			Hi,&nbsp;{{ appStore.userInfo.cnName || appStore.userInfo.realName }}
			<i class="el-icon-arrow-down"></i>
		</span>
		<template #dropdown>
			<el-dropdown-menu class="user-center-dropdown">
				<div class="user-center-dropdown__head">
					<el-link class="person-info" :underline="false" @click="userCenterCtr = true">个人中心</el-link>
					<el-link class="person-info" :underline="false" @click="modifyPwdCtr = true">修改密码</el-link>
				</div>
				<div class="user-center-dropdown__foot">
					<el-link class="btn-logout" :underline="false" @click="open">
						退出登录
						<i class="el-icon-switch-button"></i>
					</el-link>
				</div>
			</el-dropdown-menu>
		</template>
	</el-dropdown>
	<UserCenter v-model="userCenterCtr" />
	<ModifyPwd v-model="modifyPwdCtr" />
</template>

<style lang="scss" scoped>
.el-dropdown {
	&-link {
		color: var(--el-color-primary);
		cursor: pointer;
		> i {
			margin-left: 12px;
		}
	}
}
@mixin user-center-dropdown() {
	@include v-c;
	padding: 0 16px;
	height: 36px;
}
.user-center-dropdown {
	width: 240px;
	background-color: $color-white;
	box-shadow: 0 2px 5px 0 rgba(8, 15, 38, 0.1);
	border-radius: 2px;
	&__head,
	&__foot {
		@include user-center-dropdown;
		i {
			margin-left: 4px;
			color: var(--el-color-primary);
		}
	}
	&__head {
		height: unset;
		flex-direction: column;
		align-items: flex-start;
		border-bottom: 1px solid $border-color-default;
		padding-bottom: 8px;
		> a {
			width: 100%;
			padding: 8px 16px;
			i {
				margin-left: 16px;
			}
		}
	}
	&__foot {
		justify-content: center;
		.btn-logout {
			color: var(--el-color-info);
			&:hover {
				color: var(--el-color-info);
			}
		}
		i {
			color: var(--el-color-danger);
		}
	}
}
</style>
